export function BrandMark({ className = "h-9 w-9" }) {
  return <img src="/brand/logo-mark.png" alt="BudgetPulse" className={`${className} object-contain drop-shadow-[0_0_12px_rgba(46,229,157,.35)]`} />;
}

export function Brand({ size = "text-xl", mark = "h-9 w-9", hideTextOnMobile }) {
  return (
    <span className="flex items-center gap-2" data-testid="brand-logo">
      <BrandMark className={mark} />
      <span className={`mm-logo ${size} ${hideTextOnMobile ? "hidden sm:inline" : ""}`}>
        <span className="text-[var(--tx)]">Budget</span><span className="bp-grad">Pulse</span>
      </span>
    </span>
  );
}

export const Splash = ({ testId = "app-loading" }) => (
  <div className="grid min-h-screen place-items-center" data-testid={testId}>
    <BrandMark className="h-16 w-16 animate-pulse" />
  </div>
);
